"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ITEMS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _slatePlugins = require("@udecode/slate-plugins");
var _styles = require("./styles");
var _Button = require("../../Button/Button");
var BoldIcon = function BoldIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#17181A",
    fillRule: "evenodd",
    d: "M.924 10V.662h4.914c1.778 0 2.688 1.134 2.688 2.38 0 1.176-.728 1.96-1.61 2.142.994.154 1.792 1.12 1.792 2.296 0 1.4-.938 2.52-2.716 2.52H.924zm4.48-5.6c.672 0 1.092-.42 1.092-1.008 0-.588-.42-1.022-1.092-1.022H2.912V4.4h2.492zm.07 3.878c.756 0 1.204-.406 1.204-1.078 0-.588-.42-1.092-1.204-1.092H2.912v2.17h2.562z"
  }));
};
BoldIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 10"
};
var ItalicIcon = function ItalicIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#17181A",
    fillRule: "evenodd",
    d: "M1.498 10H.336L2.394.662h1.162z"
  }));
};
ItalicIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 4 10"
};
var UnderlineIcon = function UnderlineIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#17181A",
    d: "M3.9 10.168C1.366 10.168.092 8.67.092 6.374V.662h1.162v5.684c0 1.708.924 2.786 2.646 2.786s2.646-1.078 2.646-2.786V.662h1.162V6.36c0 2.324-1.274 3.808-3.808 3.808z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#D8D8D8",
    stroke: "#17181A",
    d: "M.5 11.5h7v1h-7z"
  })));
};
UnderlineIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 12"
};
var StrikeThroughIcon = function StrikeThroughIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#17181A",
    d: "M4.116 10.168c-1.624 0-2.814-.616-3.584-1.484l.686-.882c.616.686 1.624 1.33 2.94 1.33 1.666 0 2.198-.896 2.198-1.61 0-2.408-5.53-1.078-5.53-4.41 0-1.54 1.372-2.59 3.206-2.59 1.428 0 2.534.476 3.318 1.302l-.7.854c-.7-.77-1.68-1.12-2.702-1.12-1.12 0-1.918.602-1.918 1.484 0 2.1 5.53.896 5.53 4.382 0 1.358-.924 2.744-3.444 2.744z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#D8D8D8",
    stroke: "#17181A",
    d: "M1.5 5.5h6v1h-6z"
  })));
};
StrikeThroughIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 11"
};
var ITEMS = exports.ITEMS = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
  STRIKETHROUGH: 'strikethrough'
};
var TYPES = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, ITEMS.BOLD, _slatePlugins.MARK_BOLD), ITEMS.ITALIC, _slatePlugins.MARK_ITALIC), ITEMS.UNDERLINE, _slatePlugins.MARK_UNDERLINE), ITEMS.STRIKETHROUGH, _slatePlugins.MARK_STRIKETHROUGH);
var ICONS = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, ITEMS.BOLD, /*#__PURE__*/_react["default"].createElement(BoldIcon, {
  height: 10
})), ITEMS.ITALIC, /*#__PURE__*/_react["default"].createElement(ItalicIcon, {
  height: 10
})), ITEMS.UNDERLINE, /*#__PURE__*/_react["default"].createElement(UnderlineIcon, {
  height: 10
})), ITEMS.STRIKETHROUGH, /*#__PURE__*/_react["default"].createElement(StrikeThroughIcon, {
  height: 10
}));
var MarkButton = function MarkButton(_ref) {
  var name = _ref.name;
  return /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
    size: _Button.Sizes.FLEX
  }, ICONS[name]);
};
var Toolbar = /*#__PURE__*/_react["default"].memo(function (_ref2) {
  var marks = _ref2.marks,
    buttons = _ref2.buttons;
  return /*#__PURE__*/_react["default"].createElement(StyledToolBar, null, marks.map(function (mark) {
    return /*#__PURE__*/_react["default"].createElement(_slatePlugins.ToolbarMark, {
      key: mark,
      type: TYPES[mark],
      icon: /*#__PURE__*/_react["default"].createElement(MarkButton, {
        name: mark
      })
    });
  }), buttons.map(function (button) {
    return button();
  }));
});
Toolbar.propTypes = {
  marks: _propTypes["default"].arrayOf(_propTypes["default"].string),
  buttons: _propTypes["default"].arrayOf(_propTypes["default"].element)
};
Toolbar.defaultProps = {
  marks: [ITEMS.BOLD, ITEMS.ITALIC, ITEMS.UNDERLINE, ITEMS.STRIKETHROUGH],
  buttons: []
};
MarkButton.propTypes = {
  name: _propTypes["default"].string.isRequired
};
Toolbar.displayName = 'Toolbar';
var StyledToolBar = _styledComponents["default"].div.withConfig({
  displayName: "Toolbar__StyledToolBar",
  componentId: "sc-8832wk-0"
})(["display:flex;align-items:center;padding:10px 0;.slate-ToolbarButton-active{button{background:#f3f2e8;}}"]);
Toolbar.ITEMS = ITEMS;
var _default = exports["default"] = Toolbar;